import type {
  SettingTemplateGetPayload,
  SettingTemplateSelect,
  SettingValueGetPayload,
  SettingValueSelect,
} from '@erikdakoda/database/types';
import { UserForIdentificationSelect } from '@erikdakoda/auth/types';

export const SettingValueForReadSelect = {
  id: true,
  ownerId: true,
  key: true,
  value: true,
  type: true,
  app: true,
  group: true,
  public: true,
} satisfies SettingValueSelect;

export type SettingValueForRead = SettingValueGetPayload<{
  select: typeof SettingValueForReadSelect;
}>;

export const SettingValueForGridSelect = {
  id: true,
  createdAt: true,
  updatedAt: true,
  ownerId: true,
  owner: { select: UserForIdentificationSelect },
  key: true,
  type: true,
  value: true,
  group: true,
  public: true,
  app: true,
  template: {
    select: {
      spot: true,
      icon: true,
    },
  },
} satisfies SettingValueSelect;

export type SettingValueForGrid = SettingValueGetPayload<{
  select: typeof SettingValueForGridSelect;
}>;

// SettingGrid.tsx / SettingAdminPage.tsx use the shorter "Setting" name for the
// UI layer while the underlying model is SettingValue; alias so the ForGrid
// naming convention lines up with the component name.
export const SettingForGridSelect = SettingValueForGridSelect;

export type SettingForGrid = SettingValueForGrid;

export const SettingTemplateForGridSelect = {
  id: true,
  spot: true,
  group: true,
  key: true,
  type: true,
  values: true,
  default: true,
  icon: true,
  public: true,
  apps: true,
} satisfies SettingTemplateSelect;

export type SettingTemplateForGrid = SettingTemplateGetPayload<{
  select: typeof SettingTemplateForGridSelect;
}>;

export const SettingTemplateForReadSelect = {
  id: true,
  spot: true,
  group: true,
  key: true,
  type: true,
  values: true,
  default: true,
  icon: true,
  public: true,
  apps: true,
} satisfies SettingTemplateSelect;

export type SettingTemplateForRead = SettingTemplateGetPayload<{
  select: typeof SettingTemplateForReadSelect;
}>;
